import { ReactElement } from "react";
import styled from "styled-components";
import { safeIframeSrc } from "../safeUrl";

/* --------------------------------- delimiter --------------------------------- */

const Rule = styled.hr`
  border: none;
  border-top: 1px solid rgba(var(--app-color-text-rgb, 4, 23, 35), 0.12);
  width: 60%;
  margin: 10px auto;
`;

export const DelimiterBlock = (): ReactElement => <Rule />;

/* ----------------------------------- embed ----------------------------------- */

interface EmbedData {
  embed?: string;
  source?: string;
  width?: number;
  height?: number;
  caption?: string;
}

const Frame = styled.iframe<{ $ratio: string }>`
  width: 100%;
  aspect-ratio: ${({ $ratio }) => $ratio};
  border: none;
  border-radius: 16px;
  display: block;
`;

const Caption = styled.figcaption`
  font-size: 13px;
  text-align: center;
  color: rgba(var(--app-color-text-rgb, 4, 23, 35), 0.6);
  margin-top: 6px;
`;

const Figure = styled.figure`
  margin: 0;
`;

export const EmbedBlock = ({ data }: { data: EmbedData }): ReactElement | null => {
  const src = safeIframeSrc(data.embed);
  if (!src) return null;
  const ratio =
    Number(data.width) > 0 && Number(data.height) > 0
      ? `${Number(data.width)} / ${Number(data.height)}`
      : "16 / 9";
  return (
    <Figure>
      <Frame
        src={src}
        $ratio={ratio}
        allowFullScreen
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      />
      {data.caption ? <Caption>{data.caption}</Caption> : null}
    </Figure>
  );
};
